import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faEnvelope, faAlignLeft, faExclamationCircle, faRedoAlt, faMusic, faTrophy, faFlag, faAngleDoubleRight, faTimes
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import checkBox from 'vue-material-checkbox'
import 'chart.js'
import 'hchs-vue-charts'

import 'vodal/common.css'
import 'vodal/rotate.css'
import 'vodal/flip.css'
import 'vodal/slide-down.css'
import 'vodal/slide-up.css'

Vue.config.productionTip = false
Vue.use(checkBox)
Vue.use(window.VueCharts)

library.add(faEnvelope)
library.add(faAlignLeft)
library.add(faExclamationCircle)
library.add(faRedoAlt)
library.add(faMusic)
library.add(faTrophy)
library.add(faFlag)
library.add(faAngleDoubleRight)
library.add(faTimes)
Vue.component('font-awesome-icon', FontAwesomeIcon)

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
